import { Exception } from '../models';
import { parseDate } from '../../core';

export function getExceptions(exceptions: Exception[], date: string, timezone: string): Exception[] {
  if (exceptions.length && date) {
    return exceptions
      .filter(exception => parseDate(exception.date, timezone) === date);
  }

  return [];
}
